export default "__VITE_ASSET__DbLBvsy2__"